//
import MuiCard from './mui-card';
import MuiPaper from './mui-paper';
import MuiInput from './mui-input';
import MuiTable from './mui-table';
import MuiButton from './mui-button';
import MuiTooltip from './mui-tooltip';
import MuiBackdrop from './mui-backdrop';
import MuiTypography from './mui-typography';
import MuiAutocomplete from './mui-autocomplete';
import MuiSwitch from './mui-switch';
import MuiChip from './mui-chip';

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
  return Object.assign(
    MuiChip(theme),
    MuiSwitch(theme),
    MuiCard(theme),
    MuiTable(theme),
    MuiInput(theme),
    MuiPaper(theme),
    MuiButton(theme),
    MuiTooltip(theme),
    MuiBackdrop(theme),
    MuiTypography(theme),
    MuiAutocomplete(theme)
  );
}
